import contactLinkDirective from './ContactLinkDirective';
import ContactUtilsSvc from './ContactUtilsService';
import 'edge/platform/widgets/modal/module';

export default angular.module('edge.platform.contacts', ['edge.platform.widgets.modal'])
    .factory('ContactUtils', ContactUtilsSvc)
    .directive('gwPlContactLink', contactLinkDirective);
